var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartContractsTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6392 43.0659C56.8344 38.864 57.0173 30.416 51.7648 32.0974C49.4132 32.8501 46.7478 33.626 46.8186 30.5581C46.9321 25.649 51.201 21.5144 50.6164 16.0372C49.5698 6.2321 0.789 -7.35965 9.7465 4.81598C24.9663 25.5039 1.14337 19.9985 10.188 35.865C12.9095 40.6392 7.92188 40.8245 7.92188 46.6096C7.92175 72.2962 55.4722 68.192 56.6392 43.0659Z",
    fill: "url(#paint0_linear_1543_53797)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0017 10.7158H24.3051C23.6147 10.7158 23.0551 11.2754 23.0551 11.9658V14.9623H20.0586C19.3682 14.9623 18.8086 15.5219 18.8086 16.2123V44.5343C14.3213 44.5343 10.6836 48.1721 10.6836 52.6593C10.6836 57.1467 14.3213 60.7843 18.8086 60.7843C22.3488 60.7843 25.3587 58.5193 26.4721 55.3598H46.7552C47.4456 55.3598 48.0052 54.8002 48.0052 54.1098V51.1133H51.0017C51.6921 51.1133 52.2517 50.5537 52.2517 49.8633V11.9658C52.2517 11.2754 51.692 10.7158 51.0017 10.7158Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0379 34.4369C14.1551 34.5541 14.314 34.62 14.4799 34.62C14.6458 34.62 14.8046 34.5541 14.9219 34.4369L15.8511 33.5075C16.0953 33.2635 16.0953 32.8677 15.8511 32.6236C15.6071 32.3797 15.2113 32.3796 14.9673 32.6237L14.48 33.111L13.9928 32.6237C13.7488 32.3797 13.3531 32.3797 13.1089 32.6236C12.8647 32.8677 12.8647 33.2635 13.1089 33.5075L14.0379 34.4369Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9928 31.517L14.48 31.0298L14.9673 31.5169C15.0894 31.639 15.2492 31.7 15.4093 31.7C15.5693 31.7 15.7291 31.639 15.8513 31.5169C16.0954 31.2729 16.0954 30.8771 15.8513 30.6331L14.922 29.7039C14.678 29.4599 14.2824 29.4599 14.0381 29.7038L13.1089 30.633C12.8647 30.8771 12.8647 31.2729 13.1089 31.5169C13.3529 31.761 13.7486 31.761 13.9928 31.517Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4902 37.1302H15.4085C15.7536 37.1302 16.0335 36.8505 16.0335 36.5052C16.0335 36.16 15.7536 35.8802 15.4085 35.8802H11.4902C11.1451 35.8802 10.8652 36.16 10.8652 36.5052C10.8652 36.8505 11.1451 37.1302 11.4902 37.1302Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74023 39.4658H15.4085C15.7536 39.4658 16.0335 39.1861 16.0335 38.8408C16.0335 38.4956 15.7536 38.2158 15.4085 38.2158H8.74023C8.39511 38.2158 8.11523 38.4956 8.11523 38.8408C8.11523 39.1861 8.39511 39.4658 8.74023 39.4658Z",
    fill: "#F67443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0336 41.1763C16.0336 40.831 15.7537 40.5513 15.4086 40.5513H8.74023C8.39511 40.5513 8.11523 40.831 8.11523 41.1763C8.11523 41.5215 8.39511 41.8013 8.74023 41.8013H15.4085C15.7537 41.8013 16.0336 41.5215 16.0336 41.1763Z",
    fill: "#F67443"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0012 48.1133H24.3047C23.6143 48.1133 23.0547 47.5537 23.0547 46.8633V8.96582C23.0547 8.27544 23.6143 7.71582 24.3047 7.71582H51.0013C51.6917 7.71582 52.2513 8.27544 52.2513 8.96582V46.8633C52.2512 47.5537 51.6916 48.1133 51.0012 48.1133Z",
    fill: "#FFC0A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2512 14.1783V8.96582C52.2512 8.27544 51.6916 7.71582 51.0012 7.71582H24.3047C23.6143 7.71582 23.0547 8.27544 23.0547 8.96582V46.8633C23.0547 47.5537 23.6143 48.1133 24.3047 48.1133H51.0013C51.6917 48.1133 52.2513 47.5537 52.2513 46.8633V17.8898",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7552 52.3598H20.0586C19.3682 52.3598 18.8086 51.8002 18.8086 51.1098V13.2123C18.8086 12.5219 19.3682 11.9623 20.0586 11.9623H46.7552C47.4456 11.9623 48.0052 12.5219 48.0052 13.2123V51.1098C48.0052 51.8002 47.4456 52.3598 46.7552 52.3598Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1858 52.3598H46.7552C47.4456 52.3598 48.0052 51.8002 48.0052 51.1098V13.2123C48.0052 12.5219 47.4456 11.9623 46.7552 11.9623H20.0586C19.3682 11.9623 18.8086 12.5219 18.8086 13.2123V51.1098",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2797 15.9801L42.27 17.8063C42.1319 18.0562 42.3126 18.3628 42.5981 18.3628H44.6175C44.9031 18.3628 45.0839 18.0563 44.9456 17.8063L43.9359 15.9801C43.7934 15.722 43.4224 15.722 43.2797 15.9801Z",
    fill: "#FFC0A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.882 15.7865H26.6336C26.2087 15.7865 25.8162 16.0131 25.6037 16.3811L21.9796 22.6584C21.7672 23.0262 21.7672 23.4796 21.9796 23.8475L25.6037 30.1247C25.8161 30.4926 26.2087 30.7194 26.6336 30.7194H33.882C34.3068 30.7194 34.6993 30.4927 34.9118 30.1247L38.536 23.8475C38.7483 23.4796 38.7483 23.0262 38.536 22.6584L34.9118 16.3811C34.6993 16.0131 34.3068 15.7865 33.882 15.7865Z",
    fill: "#FFC0A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2166 18.4222H29.6523V28.0835",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4687 28.0835L24.6797 23.2529L27.4687 24.3696V18.4222",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6523 23.0852H31.0043",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2168 20.7292V28.0835",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8164 20.6622H34.6162L35.8899 22.9289",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.957 43.6184H43.8579",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.627 46.1661H43.8577",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.957 46.1661H37.6539",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.957 37.0792H43.8579",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8184 39.627H43.8585",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.957 39.627H27.8039",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0449 30.6952H43.8582",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.957 34.5316H43.8579",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.998 20.6622V23.1412",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0059 25.3099H44.0202",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0059 27.2025H44.0202",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 57.7843C23.2959 57.7843 26.9336 54.1466 26.9336 49.6593C26.9336 45.172 23.2959 41.5343 18.8086 41.5343C14.3213 41.5343 10.6836 45.172 10.6836 49.6593C10.6836 54.1466 14.3213 57.7843 18.8086 57.7843Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8095 56.2246C22.4355 56.2246 25.3749 53.2852 25.3749 49.6592C25.3749 46.0333 22.4355 43.0939 18.8095 43.0939C15.1836 43.0939 12.2441 46.0333 12.2441 49.6592C12.2441 53.2852 15.1836 56.2246 18.8095 56.2246Z",
    fill: "#FFC0A8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5857 48.6471L18.8157 53.9771H18.8095C18.7545 53.9771 18.7007 53.9646 18.6507 53.9408L15.062 52.2621C14.9307 52.2008 14.8457 52.0683 14.8457 51.9221V47.3958C14.8457 47.3171 14.8707 47.2421 14.9157 47.1796L19.5857 48.6471Z",
    fill: "#F67443"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7723 47.3959V51.9221C22.7723 52.0684 22.6873 52.2009 22.5561 52.2621L18.9673 53.9409C18.9173 53.9646 18.8636 53.9771 18.8086 53.9771V47.9746L22.6973 47.1721C22.7448 47.2359 22.7723 47.3134 22.7723 47.3959Z",
    fill: "#F67443"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7102 47.1871L18.8102 49.0108L14.9102 47.1871C14.9477 47.1308 15.0002 47.0858 15.0627 47.0558L18.6514 45.3771C18.7514 45.3296 18.8689 45.3296 18.9689 45.3771L22.5577 47.0558C22.6202 47.0858 22.6727 47.1308 22.7102 47.1871Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 57.7843C23.2959 57.7843 26.9336 54.1466 26.9336 49.6593C26.9336 45.172 23.2959 41.5343 18.8086 41.5343C14.3213 41.5343 10.6836 45.172 10.6836 49.6593C10.6836 54.1466 14.3213 57.7843 18.8086 57.7843Z",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5508 30.0658L14.48 30.995L15.4093 30.0658",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4093 28.0751L14.48 27.1459L13.5508 28.0751",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4086 33.5052H11.4902",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4086 35.8408H8.74023",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4086 38.1764H8.74023",
    stroke: "#F67443",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97651 27.3104L7.53906 25.8729L6.10162 27.3104L7.53906 28.7478L8.97651 27.3104Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3281 5.05256L54.8906 3.61511L53.4532 5.05256L54.8906 6.49L56.3281 5.05256Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9707 57.6179C30.6265 57.6179 31.1582 57.0863 31.1582 56.4304C31.1582 55.7746 30.6265 55.2429 29.9707 55.2429C29.3149 55.2429 28.7832 55.7746 28.7832 56.4304C28.7832 57.0863 29.3149 57.6179 29.9707 57.6179Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7109 13.1498C57.3668 13.1498 57.8984 12.6181 57.8984 11.9623C57.8984 11.3064 57.3668 10.7748 56.7109 10.7748C56.0551 10.7748 55.5234 11.3064 55.5234 11.9623C55.5234 12.6181 56.0551 13.1498 56.7109 13.1498Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6758 22.1516C14.3316 22.1516 14.8633 21.6199 14.8633 20.9641C14.8633 20.3083 14.3316 19.7766 13.6758 19.7766C13.0199 19.7766 12.4883 20.3083 12.4883 20.9641C12.4883 21.6199 13.0199 22.1516 13.6758 22.1516Z",
    stroke: "#FFC0A8",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_53797",
    x1: 6.39621,
    y1: 52.0538,
    x2: 47.2126,
    y2: 11.2374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC0A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContractsTestIcon);
export default __webpack_public_path__ + "static/media/smart-contracts-test-icon.14295e8f9bd55696a20f5cd6a91e4afc.svg";
export { ForwardRef as ReactComponent };